import React from "react";

function Pallette({ pal }) {
  return (
    <>
      <div className="pallette--wrapper">
        <ul>
          {pal.map((p) => {
            return <li key={p} style={{ background: `${p}` }}></li>;
          })}
        </ul>
      </div>
    </>
  );
}

export { Pallette };
